// SampleCard.js

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faInbox, faTruck } from '@fortawesome/free-solid-svg-icons';
import './SampleCard.css';

// The component receives 'sample' prop, which is now our correctly transformed order object.
const SampleCard = ({ sample, onClick }) => {
    const statusIcons = {
        'Order Received': faInbox,
        'Sent Cargo': faTruck,
        'Cargo Delivered': faBoxOpen, // New icon
    };

    // The onClick prop comes from the parent (SampleCardsSection).
    // This function calls it.
    const handleCardClick = () => {
        if (onClick) {
            onClick(sample);
        }
    };

    if (!sample || !sample.status) {
        return null;
    }

    return (
        // The onClick is attached here.
        <div className="samplemanager-card" onClick={handleCardClick}>
            <div className="samplemanager-card-header">
                <FontAwesomeIcon 
                    icon={statusIcons[sample.status.currentStage] || faInbox} 
                    className="samplemanager-card-icon" 
                />
                <span className="samplemanager-card-status">{sample.status.currentStage}</span>
            </div>
            <div className="samplemanager-card-body">
                <div className="samplemanager-card-patient">
                    <span className="samplemanager-card-name">{sample.firstName} {sample.lastName}</span>
                </div>
                <div className="samplemanager-card-details">
                    {/* Display the Order ID from the 'id' field we created. */}
                    <div className="samplemanager-card-detail">
                        <span className="samplemanager-card-label">Order ID:</span>
                        <span className="samplemanager-card-value">{sample.id}</span>
                    </div>
                    {/* Display the new kit summary from the 'kitType' field. */}
                    <div className="samplemanager-card-detail">
                        <span className="samplemanager-card-label">Items:</span>
                        <span className="samplemanager-card-value">{sample.kitType}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SampleCard;